/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/order */
/* eslint-disable jsx-a11y/label-has-associated-control */

import { useCallback } from "react";
import { Link } from "react-router-dom";
import { Form, Input } from "antd";
import { Key, Sms } from "iconsax-react";

import Swal from "sweetalert2";
import { useAuth } from "../../hooks/auth";

import Logo from "../../assets/images/adaptive-icon.png";
import HeroImg from "../../assets/images/lilla.png";

import {
  Container,
  SideContent,
  FormContent,
  GlassCard,
  HeroImage,
  HeroText,
  SubmitButton,
  GoogleButton,
  CardFooter,
} from "./styles";

const GoogleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.56 12.25C22.56 11.39 22.48 10.57 22.35 9.78H12V14.45H17.92C17.67 15.96 16.85 17.25 15.54 18.06V21.03H19.09C21.01 19.34 22.56 16.03 22.56 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12 23C14.97 23 17.46 22.01 19.09 21.03L15.54 18.06C14.66 18.66 13.43 19.02 12 19.02C9.24 19.02 6.89 17.15 6 14.63H2.33V17.72C4.1 21.23 7.8 23 12 23Z"
      fill="#34A853"
    />
    <path
      d="M6 14.63C5.77 13.93 5.64 13.18 5.64 12.4C5.64 11.62 5.77 10.87 6 10.17V7.08H2.33C1.6 8.52 1.18 10.16 1.18 11.9C1.18 13.64 1.6 15.28 2.33 16.72L6 14.63Z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.78C13.61 5.78 15.06 6.33 16.2 7.42L19.16 4.46C17.46 2.85 14.97 1.8 12 1.8C7.8 1.8 4.1 3.57 2.33 7.08L6 10.17C6.89 7.65 9.24 5.78 12 5.78Z"
      fill="#EA4335"
    />
  </svg>
);

interface FormProps {
  email: string;
  senha: string;
}

function Login() {
  const { signIn, signInWithGoogle, loadingAuth } = useAuth();

  const handleLogin = useCallback(
    async ({ email, senha }: FormProps) => {
      signIn({ email, password: senha });
    },
    [signIn]
  );

  const onFinishFailed = (errorInfo: any) => {
    Swal.fire({
      title: "Ocorreu um erro",
      text: "Os campos não podem estar vazios",
      icon: "error",
      showCloseButton: true,
    });
    console.log("Failed:", errorInfo);
  };

  return (
    <Container id="login-page">
      <SideContent>
        <HeroImage src={HeroImg} alt="Lilla - Bilingua" />
        <HeroText>
          <h1>Bilingua Consultoria</h1>
          <p>
            Transformando o aprendizado de Libras através da tecnologia e
            inclusão.
          </p>
        </HeroText>
      </SideContent>

      <FormContent>
        <GlassCard>
          <header>
            <img src={Logo} alt="Bilingua" />
            <h2>Bem-vindo de volta!</h2>
            <p>Acesse sua conta para continuar</p>
          </header>

          <Form
            layout="vertical"
            onFinish={handleLogin}
            onFinishFailed={onFinishFailed}
            requiredMark={false}
          >
            <Form.Item
              label="E-mail"
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: "Insira um e-mail válido!",
                },
              ]}
            >
              <Input
                placeholder="Ex: joao@email.com"
                prefix={
                  <Sms size={20} color="var(--color-primary)" variant="Bulk" />
                }
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Senha"
              name="senha"
              rules={[
                {
                  required: true,
                  message: "Insira sua senha!",
                },
                {
                  min: 6,
                  message: "A senha deve ter pelo menos 6 caracteres",
                },
              ]}
            >
              <Input.Password
                placeholder="Sua senha secreta"
                prefix={
                  <Key size={20} color="var(--color-primary)" variant="Bulk" />
                }
                size="large"
              />
            </Form.Item>

            <SubmitButton type="submit" disabled={loadingAuth}>
              {loadingAuth ? "Entrando..." : "Acessar Plataforma"}
            </SubmitButton>

            <GoogleButton
              type="button"
              onClick={signInWithGoogle}
              disabled={loadingAuth}
            >
              <GoogleIcon />
              Fazer login com o Google
            </GoogleButton>
          </Form>

          <CardFooter>
            Não tem uma conta?
            <Link to="/register">Cadastre-se agora</Link>
          </CardFooter>
        </GlassCard>
      </FormContent>
    </Container>
  );
}

export default Login;
